module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-bottom.b59766ac.svg";